import { useCallback } from 'react';
import { boundedText, maxLengthLimitError } from '../../utils/caseFieldValidation';
import type { RequiredErrors } from '../../utils/requiredValidation';

export function useWizardMaxLengthChange(
  setErrors: React.Dispatch<React.SetStateAction<RequiredErrors>>,
) {
  return useCallback(
    (errorKey: string, raw: string, max: number): string => {
      const { value, limitExceeded } = boundedText(raw, max);
      const message = maxLengthLimitError(limitExceeded);
      // Defer so callers can safely use this inside setDraft updaters without
      // triggering setState-in-render when draft lives in a parent layout.
      queueMicrotask(() => {
        setErrors((prev) => (prev[errorKey] === message ? prev : { ...prev, [errorKey]: message }));
      });
      return value;
    },
    [setErrors],
  );
}
